import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Meta (Facebook/Instagram) Pixel — ready to activate.
// To enable: set REACT_APP_META_PIXEL_ID in frontend/.env and rebuild.
// Loads ONLY after the user accepts all cookies (GDPR).
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = "scudononni_cookie_consent";

function hasFullConsent() {
  try {
    const parsed = JSON.parse(localStorage.getItem(CONSENT_KEY));
    return parsed?.value === "all";
  } catch {
    return false;
  }
}

function loadPixel() {
  if (!PIXEL_ID || window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

export default function MetaPixel() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (!PIXEL_ID) return;
    if (hasFullConsent()) loadPixel();
    const onConsentChange = (e) => {
      if (e?.detail?.value === "all") loadPixel();
    };
    window.addEventListener("scudononni:cookie-consent", onConsentChange);
    return () =>
      window.removeEventListener("scudononni:cookie-consent", onConsentChange);
  }, []);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPath.current === path) return;
    lastPath.current = path;
    if (window.fbq) window.fbq("track", "PageView");
  }, [location]);

  return null;
}
